import { render, staticRenderFns } from "./Disclamer.vue?vue&type=template&id=3b905e4a&lang=pug&"
import script from "./Disclamer.vue?vue&type=script&lang=js&"
export * from "./Disclamer.vue?vue&type=script&lang=js&"
import style0 from "./Disclamer.vue?vue&type=style&index=0&id=3b905e4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports